module.exports = __webpack_public_path__ + "media/images/restaurant/areas/kyoto_osaka_m-e71087bd768ee6954e000101c846101c.png";